import { useEffect, useState } from 'react';

import { getProjectIdFromToken, onlyUnique } from 'utils';
import { listProjects } from 'services/indexer';

import NonFungibleTokens from 'services/non-fungible-tokens';

const modifyProjects = (result, allProjects) => {
  if (result?.hits?.hits && result.hits.hits.length > 0) {
    return result.hits.hits.map((hit) => {
      for (const [key, value] of allProjects) {
        if (hit._id === getProjectIdFromToken(key)) {
          return {
            ...hit._source,
            balance: value
          };
        }
      }
    });
  }
  return [];
};

const getNFTTokens = async (accountId) => {
  let projectsList = [];

  const tokens = await NonFungibleTokens.getAllCertificates({ accountId });

  if (tokens && tokens.length > 0) {
    const allProjects = onlyUnique(tokens);
    const { result } = await listProjects(allProjects);
    projectsList = modifyProjects(result, allProjects);
  }

  return { tokens, projectsList };
};

export const sendQueryNFT = async (accountId) => {
  const { tokens, projectsList } = await getNFTTokens(accountId);

  if (tokens.length > 0 && projectsList.length > 0) {
    return tokens.map((item) => {
      return {
        ...item,
        ...item.token_metadata,
        offset_amount: +item.offset_amount,
        token_id: item.token_id,
        projects: item.tokens.map((elem) => {
          const project = projectsList.find(
            ({ project_id }) => project_id === getProjectIdFromToken(elem[0])
          );
          return {
            ...project,
            starts_at: item.token_metadata.issued_at,
            value: elem[1]
          };
        })
      };
    });
  }
  return [];
};

export const sendQueryNFTProjects = async (accountId) => {
  const { tokens, projectsList } = await getNFTTokens(accountId);

  if (tokens.length > 0 && projectsList.length > 0) {
    return tokens
      .map((item) => {
        return item.tokens.map((elem) => {
          const project = projectsList.find(
            ({ project_id }) => project_id === getProjectIdFromToken(elem[0])
          );
          return {
            ...project,
            starts_at: item.token_metadata.issued_at,
            token_amount: +elem[1]
          };
        });
      })
      .flat();
  }
  return [];
};

export const useQueryNftMetadata = (accountId, queryCallback) => {
  const [tokens, setTokens] = useState([]);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingMore] = useState(false);
  const [hasMore] = useState(false);

  useEffect(() => {
    if (!accountId) return;

    (async function () {
      setIsLoading(true);

      const data = await queryCallback(accountId);

      setTokens(data);
      setIsLoading(false);
    })();
  }, [accountId]);

  return { page, setPage, isLoading, isLoadingMore, tokens, hasMore };
};
